<h2 mat-dialog-title>Add Database</h2>
<p class="subtitle">{{ data.subTitle }}</p>
<mat-dialog-content>
  <form [formGroup]="form">
    <app-input-field
      label="Database Name"
      placeholder="Type Database Name"
      formControlName="name"
      type="text"
      hint="A unique database user will be created automatically when you add the database. After the database is created, you can view the user in the Database Users list."
    ></app-input-field>

    <app-input-field
      label="Database User Password"
      placeholder="Type Password"
      formControlName="password"
      type="password"
      autocomplete="new-password"
    ></app-input-field>

    <app-input-field
      label="Confirm Database User Password"
      placeholder="Confirm Password"
      formControlName="passwordConf"
      type="password"
      [errorMessages]="{
        required: 'Confirm password is required',
        passwordMismatch: 'Passwords do not match',
      }"
    ></app-input-field>
  </form>
</mat-dialog-content>
<mat-dialog-actions>
  <button matButton="filled" (click)="submit()" [disabled]="form.invalid">Add Database</button>
  <button matButton="elevated" (click)="close()">Close</button>
</mat-dialog-actions>
